import { injectable, inject } from 'inversify';
import type {
  IReportRepository,
  ReminderAnalyticsQuery,
  ReminderAnalyticsReportDTO,
} from '@/domain/repositories/IReportRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetReminderAnalyticsAction {
  constructor(
    @inject(TYPES.IReportRepository) private reportRepository: IReportRepository
  ) {}

  async execute(query?: ReminderAnalyticsQuery): Promise<ReminderAnalyticsReportDTO> {
    return this.reportRepository.getReminderAnalytics(query);
  }
}
